import RfqFilterModal from './rfq-filters/RfqFilterModal';
import RfqFilterButton from './rfq-filters/RfqFilterButton';
import RfqFilterForm from './rfq-filters/RfqFilterForm';

export default function BottomTabFilter() {
  return (
    <div>
      <RfqFilterModal formContent={<RfqFilterForm />} />
      <RfqFilterButton small isBottomTab />
    </div>
  );
}
